import { AxiosInstance } from 'axios';
import { createApiClient } from '../http/client';
import { ApiResponse } from '../../interfaces/common';
import { AuthService } from '../auth';

const APPOINTMENTS_API_BASE_URL = process.env.REACT_APP_PUBLIC_APPOINTMENTS_API_BASE_URL;

export interface UserPermissions {
  roles: string[];
  canAccessAdminSections: boolean;
  canOverrideAgentStatus: boolean;
  canUpdateTrackingNumbers: boolean;
  canManageCallQueues: boolean;
  // Whether the caller may see unassigned (no-clinic) records. Optional so the UI
  // tolerates an older backend that doesn't return it yet.
  canSeeUnassigned?: boolean;
}

class PermissionsService {
  private axios: AxiosInstance;

  constructor() {
    this.axios = createApiClient({
      baseURL: APPOINTMENTS_API_BASE_URL,
    });
  }

  private getAuthHeaders() {
    return {
      Authorization: `Bearer ${AuthService.getAuth()?.auth_token}`,
    };
  }

  public async fetchPermissions(): Promise<ApiResponse<UserPermissions>> {
    try {
      const response = await this.axios.get<ApiResponse<UserPermissions>>(
        '/communications/permissions',
        {
          headers: this.getAuthHeaders(),
        },
      );
      return response.data;
    } catch (error: any) {
      return {
        success: false,
        statusCode: error.response?.status || 500,
        message: error.response?.data?.message || 'Failed to fetch permissions',
      };
    }
  }
}

export default new PermissionsService();
